import React, { useEffect, useState } from 'react';
import '../CI/COD.css';
import { getRequest, getHumanReadableDate, postRequest } from '../../globalhelper/helper';
import { CSVLink } from 'react-csv';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography, Box, IconButton, TableFooter, TablePagination, TableContainer } from '@mui/material';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { hideLoader, showLoader } from '../../redux/Common/commonActions';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import LastPageIcon from '@mui/icons-material/LastPage';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
function TablePaginationActions(props) {
  const theme = useTheme();
  const {
    count,
    page,
    rowsPerPage,
    onPageChange
  } = props;
  const [previousCount, setPreviousCount] = useState(count);
  useEffect(() => {
    if (count !== previousCount && page !== 0) {
      onPageChange(null, 0);
    }
    setPreviousCount(count);
  }, [count, page, onPageChange, previousCount]);
  const handleFirstPageButtonClick = event => {
    onPageChange(event, 0);
  };
  const handleBackButtonClick = event => {
    onPageChange(event, page - 1);
  };
  const handleNextButtonClick = event => {
    onPageChange(event, page + 1);
  };
  const handleLastPageButtonClick = event => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return <Box sx={{
    flexShrink: 0,
    ml: 2.5
  }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='first page'>
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label='previous page'>
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='next page'>
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='last page'>
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>;
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired
};
const EmployeeCostReport = () => {
  const [formData, setFormData] = useState({
    fromDate: moment(),
    toDate: moment(),
    type: '',
    company: ''
  });
  const [companyDetails, setCompanyDetails] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [queryResult, setQueryResult] = useState([]);
  const [showError, setShowError] = useState(false);
  const [warningMessage, setWarningMessage] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  let dispatch = useDispatch();
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - queryResult.length) : 0;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    getRequest(`api/edureka/getCompanyAssignedToUser`).then(response => {
      const responseData = response.res.data;
      const orgname = responseData.map(item => item.orgname);
      setCompanyDetails(responseData);
      setCompanyName(orgname);
      if (orgname?.length === 1) {
        handleChange('company', orgname[0]);
      }
      var currentDate = moment();
      var firstDay = currentDate.startOf('month').format('YYYY-MM-DD');
      var lastDay = currentDate.endOf('month').format('YYYY-MM-DD');
      setFormData(prev => ({
        ...prev,
        fromDate: firstDay,
        toDate: lastDay
      }));
    });
  }, []);
  const handleSubmit = () => {
    dispatch(showLoader());
    const {
      fromDate,
      toDate,
      type,
      company
    } = formData;
    if (fromDate && toDate && type && company) {
      setShowError(false);
      const id = companyDetails.filter(item => item.orgname === company);
      const companyid = id.map(item => item.orgid);
      console.log(companyid);
      getRequest(`api/edureka/getEmployeeCostReport?startDate=${fromDate}&endDate=${toDate}&type=${type}&company=${companyid[0]}`).then(response => {
        console.log(response.res.data);
        const responseData = JSON.parse(response.res.data);
        if (responseData.length) {
          setQueryResult(responseData);
        } else {
          setShowError(true);
          setWarningMessage('No data found, please try some other combination');
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => dispatch(hideLoader()));
    } else {
      setShowError(true);
      setWarningMessage('Please select all the required fields');
    }
  };
  const handleChange = (name, value) => {
    setFormData(prev => {
      return {
        ...prev,
        [name]: value
      };
    });
  };
  const handleReset = () => {
    var currentDate = moment();
    var firstDay = currentDate.startOf('month').format('YYYY-MM-DD');
    var lastDay = currentDate.endOf('month').format('YYYY-MM-DD');
    setFormData({
      fromDate: firstDay,
      toDate: lastDay,
      type: '',
      company: ''
    });
    setQueryResult([]);
    setShowError(false);
  };
  return <>
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls='panel1-content' id='panel1-header'>
          <Typography variant='h6'>Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={1} sm={2} md={3}>
              <Autocomplete size='small' fullWidth value={formData?.company || null} options={companyName || []} onChange={(event, newValue) => handleChange('company', newValue)} renderInput={params => <TextField {...params} label='company' variant='outlined' name='company' />} />
            </Grid>

            <Grid item xs={1} sm={2} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label='From' value={formData.fromDate} inputFormat='DD-MM-YYYY' minDate={moment().subtract(1, 'year').startOf('year')} maxDate={moment().endOf('year')} views={['year', 'month', 'day']} onChange={newValue => handleChange('fromDate', moment(newValue).format('YYYY-MM-DD'))} renderInput={params => <TextField fullWidth size='small' {...params} />} />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={1} sm={2} md={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker label='To' value={formData.toDate} minDate={moment().subtract(1, 'year').startOf('year')} maxDate={moment().endOf('year')} inputFormat='DD-MM-YYYY' views={['year', 'month', 'day']} onChange={newValue => handleChange('toDate', moment(newValue).format('YYYY-MM-DD'))} renderInput={params => <TextField fullWidth size='small' {...params} />} />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={1} sm={2} md={2}>
              <Autocomplete size='small' fullWidth value={formData?.type || null} options={['detailed', 'summary'] || []} onChange={(event, newValue) => handleChange('type', newValue)} renderInput={params => <TextField {...params} label='Type' variant='outlined' />} />
            </Grid>
            <Grid item>
              <Button color='primary' variant='contained' onClick={handleSubmit} disabled={Object.values(formData).some(data => data === '' || data === null)}>
                Submit
              </Button>
              <Button onClick={handleReset} style={{
              marginLeft: '10px'
            }} color='error' variant='contained'>
                Reset
              </Button>
              &nbsp;
              {queryResult.length ? <Button color='success' variant='contained'>
                  <CSVLink data={queryResult} filename='Employee Cost Report.csv' style={{
                color: 'white',
                textDecoration: 'none'
              }}>
                    Download
                  </CSVLink>
                </Button> : null}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      {queryResult.length && formData.type === 'detailed' ? <TableContainer component={Paper}>
          <Table>
              <TableHead>
                <TableRow>
                  {((rowsPerPage > 0 ? queryResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : queryResult) && (rowsPerPage > 0 ? queryResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : queryResult).length > 0 ? Object.keys((rowsPerPage > 0 ? queryResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : queryResult)[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
              textAlign: 'left'
            }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {((rowsPerPage > 0 ? queryResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : queryResult) || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
              let displayVal = val;
              if (typeof val === 'number' && !Number.isInteger(val)) {
                displayVal = val.toFixed(2);
              } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                displayVal = parseFloat(val).toFixed(2);
              } else if (typeof val === 'boolean') {
                displayVal = val ? 'Yes' : 'No';
              } else if (val === null || val === undefined) {
                displayVal = '';
              } else if (typeof val === 'object') {
                displayVal = JSON.stringify(val);
              }
              return <TableCell key={valIndex} sx={{
                textAlign: 'left'
              }}>
                          {String(displayVal)}
                        </TableCell>;
            })}
                  </TableRow>)}
              </TableBody>
            </Table>
        </TableContainer> : null}

      {queryResult.length && formData.type === 'summary' ? <TableContainer component={Paper}>
          <Table>
              <TableHead>
                <TableRow>
                  {((rowsPerPage > 0 ? queryResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : queryResult) && (rowsPerPage > 0 ? queryResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : queryResult).length > 0 ? Object.keys((rowsPerPage > 0 ? queryResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : queryResult)[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
              textAlign: 'left'
            }}><b>{key}</b></TableCell>)}
                </TableRow>
              </TableHead>
              <TableBody>
                {((rowsPerPage > 0 ? queryResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : queryResult) || []).map((row, rowIndex) => <TableRow key={rowIndex}>
                    {Object.entries(row || {}).map(([key, val], valIndex) => {
              let displayVal = val;
              if (typeof val === 'number' && !Number.isInteger(val)) {
                displayVal = val.toFixed(2);
              } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
                displayVal = parseFloat(val).toFixed(2);
              } else if (typeof val === 'boolean') {
                displayVal = val ? 'Yes' : 'No';
              } else if (val === null || val === undefined) {
                displayVal = '';
              } else if (typeof val === 'object') {
                displayVal = JSON.stringify(val);
              }
              return <TableCell key={valIndex} sx={{
                textAlign: 'left'
              }}>
                          {String(displayVal)}
                        </TableCell>;
            })}
                  </TableRow>)}
              </TableBody>
            </Table>
        </TableContainer> : null}

      {showError && <div className='center-screen'>{warningMessage}</div>}
    </>;
};
export default EmployeeCostReport;